const blue = {
    fill: "rgba(87, 115, 153, 1)",
    fillTransparent: "rgba(87, 115, 153, 0.4)",
    border: "rgba(87, 115, 163,1)",
    gradientStops: ["rgba(87, 115, 153, 1)", "rgba(87, 115, 153, 0)"]
};

const red = {
    fill: "rgba(239, 99, 81, 1)",
    fillTransparent: "rgba(239, 99, 81, 0.4)",
    border: "rgba(239, 99, 91, 1)",
    gradientStops: ["rgba(239, 99, 81, 1)", "rgba(239, 99, 81, 0)"]
};

const green = {
    fill: "rgba(112, 151, 117, 1)",
    fillTransparent: "rgba(112, 151, 117, 0.4)",
    border: "rgba(112, 151, 127, 1)",
    gradientStops: ["rgba(112, 151, 117, 1)", "rgba(112, 151, 117, 0)"]
};

const yellow = {
    fill: "rgba(255, 188, 66, 1)",
    fillTransparent: "rgba(255, 188, 66, 0.4)",
    border: "rgba(255, 188, 76, 1)",
    gradientStops: ["rgba(255, 188, 66, 1)", "rgba(255, 188, 66, 0)"]
};

const darkYellow = {
    fill: "rgba(253, 202, 64, 1)",
    fillTransparent: "rgba(253, 202, 64, 0.4)",
    border: "rgba(253, 202, 74, 1)",
    gradientStops: ["rgba(253, 202, 64, 1)", "rgba(253, 202, 64, 0)"]
};

const grey = {
    fill: "rgba(153, 153, 161, 1)",
    fillTransparent: "rgba(153, 153, 161, 0.4)",
    border: "rgba(153, 153, 171, 1)",
    gradientStops: ["rgba(153, 153, 161, 1)", "rgba(153, 153, 161, 0)"]
};

const purple = {
    fill: "rgba(166, 128, 140, 1)",
    fillTransparent: "rgba(166, 128, 140, 0.4)",
    border: "rgba(166, 128, 150, 1)",
    gradientStops: ["rgba(166, 128, 140, 1)", "rgba(166, 128, 140, 0)"]
};
const orange = {
    fill: "rgba(255, 172, 129, 1)",
    fillTransparent: "rgba(255, 172, 129, 0.4)",
    border: "rgba(255, 172, 139, 1)",
    gradientStops: ["rgba(255, 172, 129, 1)", "rgba(255, 172, 129, 0)"]
};
const pink = {
    fill: "rgba(234, 201, 193, 1)",
    fillTransparent: "rgba(234, 201, 193, 0.4)",
    border: "rgba(234, 201, 203, 1)",
    gradientStops: ["rgba(234, 201, 193, 1)", "rgba(234, 201, 193, 0)"]
};
const greyBlue = {
    fill: "rgba(157, 180, 192, 1)",
    fillTransparent: "rgba(157, 180, 192, 0.4)",
    border: "rgba(157, 180, 202, 1)",
    gradientStops: ["rgba(157, 180, 192, 1)", "rgba(157, 180, 192, 0)"]
};
const brown = {
    fill: "rgba(193, 140, 93, 1)",
    fillTransparent: "rgba(193, 140, 93, 0.4)",
    border: "rgba(193, 140, 103, 1)",
    gradientStops: ["rgba(193, 140, 93, 1)", "rgba(193, 140, 93, 0)"]
};
const colorSets = {
    fill: [
        blue.fill,
        green.fill,
        yellow.fill,
        red.fill,
        purple.fill,
        grey.fill,
        orange.fill,
        pink.fill,
        greyBlue.fill,
        brown.fill
    ],
    border: [
        blue.border,
        green.border,
        yellow.border,
        red.border,
        purple.border,
        grey.border,
        orange.border,
        pink.border,
        greyBlue.border,
        brown.border
    ]
};
// 基礎顏色配置
const colorNames = {
    green: "#00C853",
    orange: "#f7b267",
    red: "#FF3D00",
    black: "#000",
    grey: "#9999a1"
};

module.exports = {
    blue,
    red,
    green,
    yellow,
    darkYellow,
    grey,
    purple,
    orange,
    colorSets,
    colorNames
};



// WEBPACK FOOTER //
// ./src/data/colorScheme.js